import { Component } from 'react';

class BaseStep extends Component {
  renderBuyerName = (item) => {
    const { t } = this.props;

    if (
      !item.buyer.buyer_lastName &&
      !item.buyer.buyer_firstName &&
      !item.buyer.buyer_company_name
    ) {
      if (item.agentData) {
        if (item.agentData.buyer_reference)
          return t(`Customer {buyer_reference} of {name}`, item.agentData);
        return t(`Customer of {name}`, item.agentData);
      }
      return t('Customer');
    }

    const names = [];
    names.push(`${item.buyer.buyer_firstName} ${item.buyer.buyer_lastName}`);
    if (item.buyer.buyer_type === 'company')
      names.push(item.buyer.buyer_company_name);
    if (item.buyer.others)
      item.buyer.others.forEach((buyer2) => {
        names.push(`${buyer2.buyer_firstName} ${buyer2.buyer_lastName}`);
      });
    const name = names.join(', ');
    return name;
  };
}

export default BaseStep;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/components/BaseStep.jsx